module.exports = __webpack_public_path__ + "img/marketing_sharing.abf969e7.svg";